import * as React from "react";
function SvgMagnifier(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        stroke="currentColor"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={3}
      >
        <circle cx={13} cy={13} r={11.5} />
        <path strokeLinecap="round" d="M22 22l8.5 8.5" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMagnifier);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
